import { Module } from '@/modules/core/app/constants/app.constants';
import { AudienceName, AudienceRoute } from '@/modules/audience/audiences/audiences.constants';
import { AudienceRouteConfig } from '@/modules/audience/audiences/AudienceRouteConfig';

export const router = AudienceRouteConfig.factory(
  [
    {
      path: AudienceRoute.AUDIENCES,
      name: AudienceName.AUDIENCES,
      component: () => import(/* webpackChunkName: "audiences-page" */ `./pages/AudiencesPage.vue`),
    },
    {
      path: AudienceRoute.SELECTION,
      name: AudienceName.SELECTION,
      component: () => import(/* webpackChunkName: "selection-page" */ `./pages/SelectionPage.vue`),
    },
    {
      path: AudienceRoute.TARGET,
      name: AudienceName.TARGET,
      component: () => import(/* webpackChunkName: "target-page" */ `./v1/pages/TargetPage.vue`),
    },
    {
      path: AudienceRoute.TARGET_DETAILS,
      name: AudienceName.TARGET_DETAILS,
      component: () => import(/* webpackChunkName: "target-page" */ `./v1/pages/TargetPage.vue`),
    },
    {
      path: AudienceRoute.TARGET_DETAILS_ACTION,
      name: AudienceName.TARGET_DETAILS_ACTION,
      component: () => import(/* webpackChunkName: "target-page" */ `./v1/pages/TargetPage.vue`),
    },
    {
      path: AudienceRoute.DETAILS,
      name: AudienceName.DETAILS,
      component: () => import(/* webpackChunkName: "details-page" */ `./v1/pages/DetailsPage.vue`),
    },
    {
      path: AudienceRoute.MAPPING,
      name: AudienceName.MAPPING,
      component: () => import(/* webpackChunkName: "mappings-page" */ `./v1/pages/MappingPage.vue`),
    },
    {
      path: AudienceRoute.TARGET_V2,
      name: AudienceName.TARGET_V2,
      component: () => import(/* webpackChunkName: "target-page" */ `./v2/pages/TargetPage.vue`),
    },
    {
      path: AudienceRoute.TARGET_DETAILS_V2,
      name: AudienceName.TARGET_DETAILS_V2,
      component: () => import(/* webpackChunkName: "target-page" */ `./v2/pages/TargetPage.vue`),
    },
    {
      path: AudienceRoute.TARGET_DETAILS_ACTION_V2,
      name: AudienceName.TARGET_DETAILS_ACTION_V2,
      component: () => import(/* webpackChunkName: "target-page" */ `./v2/pages/TargetPage.vue`),
    },
    {
      path: AudienceRoute.DETAILS_V2,
      name: AudienceName.DETAILS_V2,
      component: () => import(/* webpackChunkName: "details-page" */ `./v2/pages/DetailsPage.vue`),
    },
    {
      path: AudienceRoute.MAPPING_V2,
      name: AudienceName.MAPPING_V2,
      component: () => import(/* webpackChunkName: "mappings-page" */ `./v2/pages/MappingPage.vue`),
    },
    {
      path: AudienceRoute.MAPPING_V2_DETAILS,
      name: AudienceName.MAPPING_V2_DETAILS,
      component: () => import(/* webpackChunkName: "mappings-page" */ `./v2/pages/MappingPage.vue`),
    },
  ],
  Module.AUDIENCE
);
